import { Link } from 'react-router-dom';
import { onboardingHref } from '../lib/onboarding-model';
import { Alert, Badge, Button, Card, Spinner } from '@aigovops/design-system';
import { useQuery } from '@tanstack/react-query';
import { getSystemBuildChecks } from '../lib/lifecycle-api';
import { queryKeys } from '../lib/query-keys';
import { fmtDate } from '../lib/format';
export function SystemBuildChecks({ slug, systemId }: { slug: string; systemId: string }) {
  const buildQuery = useQuery({
    queryKey: queryKeys.buildChecks(slug, systemId),
    queryFn: () => getSystemBuildChecks(slug, systemId),
    enabled: !!slug && !!systemId,
  });
  const q = {
    data: buildQuery.data ?? null,
    error: buildQuery.error?.message ?? null,
    loading: buildQuery.isLoading,
    refetch: () => { buildQuery.refetch(); },
  };
  if (q.loading) return <Spinner label="Loading governance check results" />;
  if (q.error) return <Alert variant="error">Check results could not be loaded. <Button onClick={q.refetch}>Retry check results</Button></Alert>;
  const result = q.data;
  return <section className="v75-stack"><h2>Latest governance check</h2>{!result?.submission ? <p>No governance check has been received for this system.</p> : <><p>Submitted {fmtDate(result.submission.submitted_at)} · Artifact processing: {result.submission.parse_status}</p>{result.submission.parse_error && <Alert variant="error">{result.submission.parse_error}</Alert>}{!result.checks.length && <p>No control verdicts were recorded for this submission. The governance result is unknown.</p>}{result.checks.map(check => <Card key={check.check_id}><div className="v75-panel"><h3>{check.control_id} · {check.title}</h3><Badge>{check.status.replace(/_/g, ' ')}</Badge>{check.message ? <p>{check.message}</p> : <p>No finding message was supplied by this check.</p>}{check.requirement && <p>Requirement: {check.requirement}</p>}<Link to="?tab=controls">Review control requirements and remediation</Link></div></Card>)}</>}
    <Link to={onboardingHref(slug, 'first_run', { system: systemId })}>Set up or rerun a governance check</Link>
  </section>;
}
